enum RoleEnum {
    ADMIN = 'admin',
    ASSISTANT = 'assistant',
    ASSISTANT_MANAGER = 'assistant_manager',
    CONTENT_EDITOR = 'content_editor',
    CONTENT_MANAGER = 'content_manager',
    MARKETING_MANAGER = 'marketing_manager',
    NEWS_WRITER = 'news_writer',
    TRANSLATOR = 'translator_',
    TRANSLATOR_BR = 'translator_br',
    TRANSLATOR_CN = 'translator_cn',
    TRANSLATOR_ES = 'translator_es',
    TRANSLATOR_FR = 'translator_fr',
    TRANSLATOR_ID = 'translator_id',
    TRANSLATOR_JP = 'translator_jp',
    TRANSLATOR_RU = 'translator_ru',
    TRANSLATOR_TR = 'translator_tr',
    TRANSLATOR_VN = 'translator_vn',
    USER = 'user',
}

export default RoleEnum;

export const ROLES = Object.values(RoleEnum);
